/**
 * Flap / Corla 官方 RWA 底池 logo 路径（flap.sh 静态资源）
 * @see corla c8d3388fb2c63.js rwaQuoteTokens
 */
export const FLAP_ASSET_BASE = "https://flap.sh";

/** symbol → flap.sh 站内路径 */
export const FLAP_RWA_LOGO_PATHS = {
  SPCXB: "/spcxb.svg",
  SKHYB: "/skyhb.svg",
  SPYB: "/spyb.svg",
  XAUT: "/xaut.svg",
  QQQB: "/payment-token-catalog/qqqb.svg",
  NVDAB: "/payment-token-catalog/nvdab.svg",
  AAPLB: "/payment-token-catalog/aaplb.svg",
  AMZNB: "/payment-token-catalog/amznb.svg",
  TSLAB: "/payment-token-catalog/tslab.svg",
  MSFTB: "/payment-token-catalog/msftb.svg",
  METAB: "/payment-token-catalog/metab.svg",
  MSTRB: "/payment-token-catalog/mstrb.svg",
  HOODB: "/payment-token-catalog/hoodb.svg",
  BABAB: "/payment-token-catalog/babab.svg",
  GMEB: "/payment-token-catalog/gmeb.svg",
  GOOGLB: "/payment-token-catalog/googlb.svg",
  DJTB: "/payment-token-catalog/djtb.svg",
  NFLXB: "/payment-token-catalog/nflxb.svg",
  NOKB: "/payment-token-catalog/nokb.svg",
  TSMB: "/payment-token-catalog/tsmb.svg",
  SOXLB: "/payment-token-catalog/soxlb.svg",
  SOXSB: "/payment-token-catalog/soxsb.svg",
  MRNAB: "/payment-token-catalog/mrnab.svg",
  FLNCB: "/payment-token-catalog/flncb.svg",
};

export function hasFlapRwaLogo(symbol) {
  const sym = String(symbol || "").trim().toUpperCase();
  return !!FLAP_RWA_LOGO_PATHS[sym];
}

/** Corla / Flap 部署页同款直链 */
export function flapRwaLogoUrl(symbol) {
  const sym = String(symbol || "").trim().toUpperCase();
  const path = FLAP_RWA_LOGO_PATHS[sym];
  if (!path) return "";
  return `${FLAP_ASSET_BASE}${path}`;
}

/** 同源代理（api/flap_logo.php），浏览器无法直连 flap 时用 */
export function flapRwaLogoProxyUrl(symbol) {
  const sym = String(symbol || "").trim().toUpperCase();
  const path = FLAP_RWA_LOGO_PATHS[sym];
  if (!path) return "";
  return `/api/flap_logo.php?path=${encodeURIComponent(path)}`;
}
